import React, { useState } from 'react';
import InputField from '../../../../common/InputField';
import CommonCheckBox from '../../../../common/CommonCheckBox';
import SelectOption from '../../../../common/SelectOption';
import TimeRangePicker from '../../../../common/TimePicker/TimeRangePicker';
import { Form, Select, Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import useInputValidator from '../../../../../hooks/useInputValidator';
import HourlyPricingOption from './HourlyPricingOption/HourlyPricingOption';
import InputNumberField from '../../../../common/InputNumberField';
import { defaultMemoize, createSelectorCreator } from 'reselect';
import isEqual from 'lodash.isequal';
import { useEffect } from 'react';
import DailyPricingOption from './DailyPricingOption/DailyPricingOption';
import BlockPricingOption from './BlockPricingOption/BlockPricingOption';
import FieldName from '../../../../../components/common/FieldName';
import Amenities from '../Amenities/Amenities';
import Addons from '../Addons/Addons';
import KeepInMind from '../KeepInMind/KeepInMind';
import {SPACE_CATEGORY, SPACE_PAYMENT_OPTIONS, units} from '../../../../common/constants';
import { PricingOptionValidation } from '../../../../../helper/spaceFormValidation';
import {numberOfSeatValidation, spaceAreaValidation} from "../../../../../helper/FeildValidations";
import Packages from "../Packages/Packages";
import { getPricingOptionsDayArray } from '../../SpaceAction';

const MeetAndTrain = ({ name, currency, form, isEdit, category }) => {
  const { value, handleChange, resetSeatArragement } = useInputValidator({
    isStandingAvailable: false,
    isCocktailAvailable: false,
    isTheaterAvailable: false,
    isBoardroomAvailable: false,
    isHollowAvailable: false,
    isBanquetAvailable: false,
    isClassroomAvailable: false,
    isUShapeAvailable: false,
    isCabaretAvailable: false,
  });

  //  console.log({value})

  const filterByCategory =
    category === 'Shoot'
      ? (i) => i.name === 'Hourly' || i.name === 'Block'
      : (i) => i.name === 'Daily' || i.name === 'Hourly' || i.name === 'Block';
  const dispatch = useDispatch();
  const formFields = isEdit ? form.getFieldValue() : null;
  const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
  const [maximumSeat, setMaximumSeat] = useState(formFields?.maximumSeats || null);
  const [selectedPricingOptions, setSelectedPricingOption] = useState([]);
  const cancellationPolicies = useSelector(state => state.space?.cancellationPolicies?.data || []);
  const seatingArrangements = useSelector(state => state.space?.seatingArrangement?.data || []);
  const activityId = form.getFieldValue("eventId") || [];
  const spaceActivities = useSelector(state => state.space?.spaceCategory?.data?.[1]?.venueType || []);
  const paymentOptions = useSelector(state => state.space?.paymentOptions?.data.filter(filterByCategory) || []);
  const [optionValues, setOptionValues] = useState(paymentOptions);  
  const savedSeatArrangements = useSelector(state => state.space?.spaceDetails?.data?.seatArrangements || []);

  //  console.log({seatingArrangements})

  // console.log({savedSeatArrangements})

  const handleSelected = (option) => {
    setSelectedPricingOption([...selectedPricingOptions, option]);
  };
  const deselectItems = (option) => {
    let chargings =  form.getFieldValue(['chargings']);
    chargings = chargings.filter((charging) => charging.chargingType.id !== option)
    form.setFieldsValue({
      chargings
    })
    const changeValue = selectedPricingOptions.filter((i) => i !== option);
    setSelectedPricingOption(changeValue);
  };

  const recompose = (selectorFunction) => {
    return createDeepEqualSelector(selectorFunction, state => state)
  }

  const handleMaximumSeatChange = (e) => {
    try {
      const maximumSeatValue = parseInt(e.target.value);
      setMaximumSeat(maximumSeatValue);
    } catch (err) {}
  };

  useEffect(() => {
    if(isEdit){
      setOptionValues(PricingOptionValidation(paymentOptions,formFields.pricingOption));
      setSelectedPricingOption(formFields.pricingOption);
      setMaximumSeat(formFields?.maximumSeats);
      if(formFields.seatArrangements && formFields.seatArrangements.length > 0){
        const initFormSeats = []
          formFields.seatArrangements.map(defSeat =>{
            seatMapper.map((mapper, mapperIndex) => {
              if(defSeat?.seatArrangement?.name === mapper?.name){
                value[mapper.stateName] = true
                initFormSeats[mapperIndex] = {seatArrangement: {id: defSeat.seatArrangement.id}, min: defSeat.min}
              }
            })
          })
          form.setFieldsValue({seatArrangements: initFormSeats});
      }
    }
  },[formFields?.id]);

  useEffect(() => {
    setOptionValues(PricingOptionValidation(paymentOptions,selectedPricingOptions));
  }, [selectedPricingOptions, category]);

  useEffect(()=>{
    dispatch(getPricingOptionsDayArray(selectedPricingOptions));
  },[selectedPricingOptions])

  // useEffect(()=> {
  //   resetSeatArragement({
  //     isStandingAvailable: false,
  //     isCocktailAvailable: false,
  //     isTheaterAvailable: false,
  //     isBoardroomAvailable: false,
  //     isHollowAvailable: false,
  //     isBanquetAvailable: false,
  //     isClassroomAvailable: false,
  //     isUShapeAvailable: false,
  //     isCabaretAvailable: false
  //   })
  // }, [])

  const seatMapper = [
    { name: 'Standing', stateName: 'isStandingAvailable' },
    { name: 'U-Shape', stateName: 'isUShapeAvailable' },
    { name: 'Hollow Square', stateName: 'isHollowAvailable' },
    { name: 'Banquet', stateName: 'isBanquetAvailable' },
    { name: 'Cocktail', stateName: 'isCocktailAvailable' },
    { name: 'Theater', stateName: 'isTheaterAvailable' },
    { name: 'Boardroom', stateName: 'isBoardroomAvailable' },
    { name: 'Classroom', stateName: 'isClassroomAvailable' },
    { name: 'Cabaret', stateName: 'isCabaretAvailable' }
  ];

  const print = () => {
    seatMapper.map((seat,mapperIndex) => console.log({mapperIndex}))
  }

  useEffect(() => {
    print()
  },[])


  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];
 
  const getOptions = () => {
    if(selectedPricingOptions.length){
        return paymentOptions.map(paymentOption =>  
            selectedPricingOptions.map((selectedPricingOption) => {
              const {name} = paymentOptions.find(i => i.id === selectedPricingOption);
              if(name == 'Hourly' && paymentOption === 'Block'){
                  return
              }
              else if(name == 'Block' && paymentOption === 'Hourly'){
                return;
              }else{
                return paymentOption
              }
            })
        )
    }
    return paymentOptions
  }

  const getPaymentOptionName = (id) => {
    const option = paymentOptions?.find((i) => i.id === id);
    return option?.name || null;  
  };

  const getVenueName = (activityId) => {
      const [selectedActivityId] = activityId;
      const { name } = spaceActivities.find((i) => i.id === selectedActivityId)
        ? spaceActivities.find((i) => i.id === selectedActivityId)
        : {name:null};
      return name;
  };

//  console.log({seatingArrangements})
//  console.log(savedSeatArrangements)



  return (
    <div className="basic-details-wrapper">

      <InputField
          name={'maximumSeats'}
          label={'Number Of Seats'}
          rules={numberOfSeatValidation}
          handleOnChange={handleMaximumSeatChange}
      />

      <InputField name={['spaceArea', 'amount']} label={'Space Area'} rules={spaceAreaValidation} />
      <SelectOption
        isMultiple={false}
        name={['spaceArea','unit']}
        placeholder={'units'}
        rules={[
          {
            required: true
          }
        ]}
        label={'Unit'}
        values={units}
        handleOnSelect={null}
        labelName={'label'}
        valueName={'name'}
      />

      {category === 'Meet' &&
      <h3>Seat Arrangments</h3>
      } 
      {category === 'Meet' && seatingArrangements.map((seat, index) => {
        
          return seatMapper.map((mapperSeat, mapperIndex) => {
              { return mapperSeat.name === seat.name &&  <>
            <Row>
            <Col offset={8}></Col>
            <Col span={16}>
              <CommonCheckBox
                 label={seat.name}
                 handleOnChange={e => handleChange([mapperSeat.stateName], e.target.checked)}
                 checked={value[mapperSeat.stateName]}
               />
               {value[mapperSeat.stateName] && (
                <>

                  <Form.Item name={['seatArrangements', mapperIndex, 'seatArrangement']}>
                    <FieldName fieldName={'id'} fieldValue={seat.id} />
                  </Form.Item>
                    <InputNumberField
                      name={['seatArrangements', mapperIndex, 'min']}
                      label={seat.name}
                      rules={rules}
                      maxAmount={maximumSeat}
                      defaultValue={
                        savedSeatArrangements?.[ savedSeatArrangements.findIndex((s) => s.seatArrangement?.name === seat.name)]?.min
                      }
                    />
                 </>

               )}
               </Col>
               </Row>
             </>}
            
          })

      })}

      <SelectOption
        isMultiple={false}
        name={['cancellationPolicy', 'id']}
        placeholder={'Cancellation Policies'}
        rules={rules}
        label={'Cancellation Policies'}
        values={cancellationPolicies}
        valueName={'id'}
        labelName={'name'}
        handleOnSelect={null}
      />

      {category === 'Meet' &&
        <Row>
          <Col offset={8}></Col>
          <Col span={16}>
            <CommonCheckBox
              name={'refundableAgainstFAndB'}
              label={'Refundable against F&B'}
              handleOnChange={null}
            />
          </Col>
        </Row> 
      }
      <SelectOption
        isMultiple={true}
        name={['pricingOption']}
        placeholder={'Charging Types'}
        rules={rules}
        label={'Charging Types'}
        values={optionValues}
        handleOnSelect={handleSelected}
        handleOnDeselect={deselectItems}
        labelName={'name'}
        valueName={'id'}
      />
        {selectedPricingOptions?.map((option, index) => {
            if ( getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.HOURLY) {
                return (
                    <Packages
                        form={form}
                        paymentOption={SPACE_PAYMENT_OPTIONS.HOURLY}
                        packageCategory={SPACE_CATEGORY.MEETING}
                        meetIndex={0}
                        pricingOptionIndex={index}
                        isEdit={isEdit}
                    />
                );
            }
            if ( getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.DAILY) {
                return (
                    <Packages
                        form={form}
                        paymentOption={SPACE_PAYMENT_OPTIONS.DAILY}
                        packageCategory={SPACE_CATEGORY.MEETING}
                        meetIndex={0}
                        pricingOptionIndex={index}
                        isEdit={isEdit}
                    />
                );
            }
            if ( getPaymentOptionName(option) === SPACE_PAYMENT_OPTIONS.BLOCK) {
                return (
                    <Packages
                        form={form}
                        paymentOption={SPACE_PAYMENT_OPTIONS.BLOCK}
                        packageCategory={SPACE_CATEGORY.MEETING}
                        meetIndex={0}
                        pricingOptionIndex={index}
                        isEdit={isEdit}
                    />
                );
            }
        })}

      {selectedPricingOptions?.map((option, index) => {
          if (getPaymentOptionName(option) === 'Hourly') {
            return <HourlyPricingOption 
                      paymentOptionIndex={index}
                      paymentOptionId={option}
                      form={form}
                      currency={currency}
                      isEdit={isEdit}
                      />
          }
          if (getPaymentOptionName(option) === 'Daily') {
            return <DailyPricingOption 
                      paymentOptionIndex={index}
                      paymentOptionId={option}
                      form={form}
                      currency={currency}
                      isEdit={isEdit}
                      />
          }
          if (getPaymentOptionName(option) === 'Block') {
            return <BlockPricingOption 
                      paymentOptionIndex={index}
                      paymentOptionId={option}
                      form={form}
                      currency={currency}
                      isEdit={isEdit}
                      />
          }
      })}
      
      <Amenities name={'amenities'} category={category}/>
      
      {isEdit && formFields.spaceAddOns ? 
      (<div><Addons name={['addOns']} formAddOns={formFields.spaceAddOns} isEdit={isEdit} />
      <KeepInMind name={['keepInMindMeet']} formKeepInMinds={formFields.keepInMind} isEdit={isEdit}  /></div>)
      :(<><Addons name={['addOns']}  />
      <KeepInMind name={['keepInMindMeet']}   /></>) }
      
      <hr></hr>
    </div>
  );
};

export default MeetAndTrain;
